/**
 *
 * LoaderDots
 *
 */
import React, { memo, useRef, useEffect } from 'react';
import { Wrapper, StyledDotsCircleOne, StyledDotsCircleTwo, StyledDotsCircleThree, StyledSVG } from './styles';

interface Props {
  /** Sets the height and width in pixels. Inherits the parent's font size by default. */
  size?: string | number;
  /** Sets the continer width. Default 100%. */
  containerWidth?: string | number;
  /** Sets the continer height. Default 100%. */
  containerHeight?: string | number;
  /** Sets the continer alignItems. Default center. */
  containerFlexAlign?: string;
  /** Sets the continer justifyContetn. Default center. */
  containerFlexJustify?: string;
  /** Sets the length of the animation cycle in milliseconds **/
  duration?: number;
  /** Sets all white loader **/
  white?: boolean;
}

export const LoaderDots = memo(
  ({
    size = '40px',
    containerWidth,
    containerHeight,
    containerFlexAlign,
    containerFlexJustify,
    duration = 1000,
    white = false,
  }: Props) => {
    const canTransformSVG = useRef<boolean | null>(null);

    const dotOne = useRef<SVGCircleElement>(null);
    const dotTwo = useRef<SVGCircleElement>(null);
    const dotThree = useRef<SVGCircleElement>(null);

    useEffect(() => {
      if (!canTransformSVG.current) {
        const transforms = [
          window.getComputedStyle(dotOne.current!).getPropertyValue('transform'),
          window.getComputedStyle(dotTwo.current!).getPropertyValue('transform'),
          window.getComputedStyle(dotThree.current!).getPropertyValue('transform'),
        ];

        dotOne.current!.setAttribute('transform', transforms[0]);
        dotTwo.current!.setAttribute('transform', transforms[1]);
        dotThree.current!.setAttribute('transform', transforms[2]);
      }
    });

    return (
      <Wrapper
        width={containerWidth ?? '100%'}
        height={containerHeight ?? '100%'}
        alignItems={containerFlexAlign ?? 'center'}
        justifyContent={containerFlexJustify ?? 'center'}
      >
        <StyledSVG fontSize={size!} width="80" height="72">
          <g fill="currentColor">
            <StyledDotsCircleOne duration={duration!} color={white ? 'whites.0' : 'blues.2'} ref={dotOne} />
            <StyledDotsCircleTwo duration={duration!} color={white ? 'whites.0' : 'oranges.2'} ref={dotTwo} />
            <StyledDotsCircleThree duration={duration!} color={white ? 'whites.0' : 'yellows.2'} ref={dotThree} />
          </g>
        </StyledSVG>
      </Wrapper>
    );
  },
);
